"use strict";

var _objectWithoutProperties = require("/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/objectWithoutProperties.js");

const _excluded = ["className", "type"];

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _westfieldLogoInline = _interopRequireDefault(require("../../images/westfield-logo.inline.svg"));

var _westfieldLogoRedInline = _interopRequireDefault(require("../../images/westfield-logo-red.inline.svg"));

var _directDigitalLogoInline = _interopRequireDefault(require("../../images/direct-digital-logo.inline.svg"));

var _directMarketingLogoInline = _interopRequireDefault(require("../../images/direct-marketing-logo.inline.svg"));

var _westfieldOnlineLogoInline = _interopRequireDefault(require("../../images/westfield-online-logo.inline.svg"));

var _westfieldPlusInline = _interopRequireDefault(require("../../images/westfield-plus.inline.svg"));

var _westfieldMembershipLogoInline = _interopRequireDefault(require("../../images/westfield-membership-logo.inline.svg"));

var _indexModule = _interopRequireDefault(require("./index.module.scss"));

const LogoWithoutLink = _ref => {
  let {
    className,
    type = 'default'
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  switch (type) {
    case 'direct-digital':
    case 'direct-digital-mono':
      return /*#__PURE__*/_react.default.createElement(_directDigitalLogoInline.default, (0, _extends2.default)({}, props, {
        className: (0, _classnames.default)(className, _indexModule.default[type]),
        "data-testid": type
      }));

    case 'direct-marketing':
    case 'direct-marketing-mono':
      return /*#__PURE__*/_react.default.createElement(_directMarketingLogoInline.default, (0, _extends2.default)({}, props, {
        className: (0, _classnames.default)(className, _indexModule.default[type]),
        "data-testid": type
      }));

    case 'westfield-online':
      return /*#__PURE__*/_react.default.createElement(_westfieldOnlineLogoInline.default, (0, _extends2.default)({}, props, {
        className: (0, _classnames.default)(className, _indexModule.default[type]),
        "data-testid": type
      }));

    case 'westfield-plus':
      return /*#__PURE__*/_react.default.createElement(_westfieldPlusInline.default, (0, _extends2.default)({}, props, {
        className: (0, _classnames.default)(className, _indexModule.default[type]),
        "data-testid": type
      }));

    case 'westfield-membership':
      return /*#__PURE__*/_react.default.createElement(_westfieldMembershipLogoInline.default, (0, _extends2.default)({}, props, {
        className: (0, _classnames.default)(className, _indexModule.default[type]),
        "data-testid": type
      }));

    case 'westfield-logo-red':
      return /*#__PURE__*/_react.default.createElement(_westfieldLogoRedInline.default, (0, _extends2.default)({}, props, {
        className: (0, _classnames.default)(className, _indexModule.default[type]),
        "data-testid": type
      }));

    default:
      return /*#__PURE__*/_react.default.createElement(_westfieldLogoInline.default, (0, _extends2.default)({}, props, {
        className: (0, _classnames.default)(className, _indexModule.default[type]),
        "data-testid": type
      }));
  }
};

var _default = exports.default = LogoWithoutLink;